{
  "about": {
    "paragraph": "우리는 AGEC 법의 도전에 대응하고 고객에게 제품의 원산지와 환경적 품질에 대해 정보를 제공하는 데 전념하고 있습니다.",
    "title": "소개"
  },
  "lastUpdate": "마지막 업데이트 날짜: ",
  "loading": {
    "dataPending": "현재 이 정보를 수집 중입니다",
    "pendingLocation": "위치 대기 중"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "의류 제조",
    "FOOTWEAR_FINISHING": "신발 마감",
    "FOOTWEAR_STITCHING": "신발 봉제",
    "FOOTWEAR_ASSEMBLING": "신발 조립",
    "FABRIC_WEAVING_OR_KNITTING": "직물 직조 또는 편직",
    "FABRIC_DYEING_PRINTING": "직물 염색 또는 인쇄",
    "YARN_PROVIDER": "실 공급업체",
    "YARN_DYEING_PRINTING": "실 염색 또는 인쇄",
    "LEATHER_TANNING": "가죽 무두질",
    "LEATHER_DYEING_PRINTING": "가죽 염색 또는 인쇄",
    "ACCESSORY_PROVIDER": "액세서리 공급업체",
    "YARN_MATERIAL_PRODUCTION": "실 재료 생산",
    "FABRIC_SPINNING": "직물 방적",
    "FABRIC_MATERIAL_PRODUCTION": "직물 재료 생산",
    "LEATHER_MATERIAL_PRODUCTION": "가죽 재료 생산",
    "LEATHER_FARM": "사육 농장",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "액세서리 원자재 공급업체",
    "COATING": "코팅"
  },
  "other": {
    "microplastics_bold": "미세플라스틱을 방출합니다 ",
    "paragraph1": "이 제품에는 ",
    "paragraph1_100": "이 제품에는 100% 재활용 재료가 포함되어 있습니다.",
    "paragraph2_1": "이 제품은 ",
    "paragraph2_2": "  세탁 중 환경으로 방출합니다: ",
    "paragraph2_3": "제품 질량의 합성 섬유로 구성되어 있습니다.",
    "paragraph3": "응용 프로그램에서 유해 물질의 잠재적 존재에 대한 정보: ",
    "recycled_matertials_bold": "최소 {{percent}}% 재활용 재료.",
    "recycled_matertials_bold_50": "50% 이상 ",
    "title": "기타 환경적 품질 및 특징"
  },
  "packaging": {
    "recyclable": "재활용 가능: 포장은 재활용 가능합니다.",
    "recycled": "재활용 재료: 포장에는 최소 {{percent}}% 재활용 재료가 포함되어 있습니다.",
    "recycled_100": "재활용 재료: 포장에는 100% 재활용 재료가 포함되어 있습니다.",
    "title": "포장의 환경적 품질 및 특징"
  },
  "title": "환경적 품질 또는 특성에 대한 제품 시트",
  "traceability": {
    "paragraph": "이는 제품의 생성부터 주요 재료의 직조 및 염색까지, 첫 세 단계의 생산 단계에서 제품의 원산지를 나타냅니다.",
    "title": "제품 추적성"
  },
  "ecoScore": {
    "title": "에코스코어"
  }
}
